var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166626 8.99996C0.166626 4.39996 3.89996 0.666626 8.49996 0.666626C13.1 0.666626 16.8333 4.39996 16.8333 8.99996C16.8333 13.6 13.1 17.3333 8.49996 17.3333C3.89996 17.3333 0.166626 13.6 0.166626 8.99996ZM1.83329 8.99996C1.83329 12.6833 4.81663 15.6666 8.49996 15.6666C12.1833 15.6666 15.1666 12.6833 15.1666 8.99996C15.1666 5.31663 12.1833 2.33329 8.49996 2.33329C4.81663 2.33329 1.83329 5.31663 1.83329 8.99996Z",
    fill: "#8A9EA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBorder);
export default __webpack_public_path__ + "static/media/circle-border.ed7dfcd15ed0ab91deb3a8f5a504214d.svg";
export { ForwardRef as ReactComponent };